import React, { useEffect, useState } from 'react'
import { Avatar } from 'antd'
import { getRandomColor } from '@helpers'
import styles from './styles.module.scss'

interface IUserAvatar {
  name?: string
  email?: string
  avatar?: string
}

export const UserAvatar: React.FC<IUserAvatar> = React.memo(
  ({ name, email, avatar }) => {
    const [color, setColor] = useState('')

    useEffect(() => {
      setColor(getRandomColor)
    }, [])

    return (
      <div
        className={`rankmiSignature-optionsButton--avatar ${styles.container}`}
      >
        {avatar ? (
          <Avatar
            src={avatar}
            className='rankmiSignature-optionsButton--avatar-image'
          />
        ) : (
          <Avatar
            style={{ backgroundColor: color }}
            className='rankmiSignature-optionsButton--avatar-image'
          >
            {(name && name[0]) || ''}
          </Avatar>
        )}
        <div className={styles.rightSide}>
          <p
            className={`rankmiSignature-optionsButton--avatar-username ${styles.userName}`}
          >
            {name}
          </p>
          {email && (
            <small
              className={`masterApp-optionsButton--avatar-email ${styles.userEmail}`}
            >
              {email}
            </small>
          )}
        </div>
      </div>
    )
  }
)
